var _path, _path2, _circle, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTransaction(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Icons",
    viewBox: "0 0 60 60",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m45.73 27.07 12.34-10.09c1.24-1.02 1.24-2.96 0-3.97l-14.03-11.471c-1.62-1.29-4.04-.12-4.04 1.98v5.48h-37c-1.1 0-2 .9-2 2v8c0 1.1.9 2 2 2h13.76l28.97 6.07z",
    fill: "#7db936"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m14.27 32.93-12.34 10.09c-1.24 1.02-1.24 2.96 0 3.97l14.03 11.47c1.62 1.29 4.04.12 4.04-1.98v-5.48h37c1.1 0 2-.9 2-2v-8c0-1.1-.9-2-2-2h-13.76z",
    fill: "#d83030"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 30,
    cy: 30,
    fill: "#fcc029",
    r: 16
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#ffe73b"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m37 34.5c0-2.765-2.614-5.054-6-5.437v-6.975c2.952.484 4.016 3.005 4.069 3.136.202.513.782.767 1.293.565.515-.2.77-.779.569-1.294-.066-.171-1.581-3.922-5.932-4.434v-1.061c0-.553-.447-1-1-1s-1 .447-1 1v1.063c-3.386.383-6 2.672-6 5.437s2.614 5.054 6 5.437v6.975c-2.96-.486-4.022-3.018-4.068-3.132-.199-.516-.781-.771-1.294-.569-.515.2-.77.779-.569 1.294.066.171 1.581 3.922 5.932 4.434v1.061c0 .553.447 1 1 1s1-.447 1-1v-1.063c3.386-.383 6-2.672 6-5.437zm-12-9c0-1.658 1.75-3.091 4-3.426v6.852c-2.25-.335-4-1.767-4-3.426zm6 12.426v-6.852c2.25.335 4 1.767 4 3.426s-1.75 3.091-4 3.426z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m30 47c-9.374 0-17-7.626-17-17s7.626-17 17-17 17 7.626 17 17-7.626 17-17 17zm0-32c-8.271 0-15 6.729-15 15s6.729 15 15 15 15-6.729 15-15-6.729-15-15-15z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTransaction);
export default __webpack_public_path__ + "static/media/transaction.eede2e54029b2f6d0fd0386a4dc33157.svg";
export { ForwardRef as ReactComponent };